const doc = [({"en":({"js":({"admin":({"elements":({"table":({"view_element":"View element"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;